import axios from "axios";
import { jwtDecode } from "jwt-decode";
import config from "../config.json";
import { userRefreshTokenLogin } from "./AuthService";
export const createAxiosInstance = (baseURL: string) => {
  const concludedUrl = baseURL.startsWith("http")
    ? baseURL
    : `${window.location.protocol}//${window.location.hostname}/api${baseURL}`;
  console.log(concludedUrl);
  const instance = axios.create({
    baseURL: concludedUrl,
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Request interceptor to add the Authorization header
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle token expiration and refreshing
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response && error.response.status === 401) {
        try {
          const refreshToken = localStorage.getItem("refresh_token");
          if (!refreshToken) {
            throw new Error("refresh token is missing");
          }
          const response = await userRefreshTokenLogin(refreshToken);

          if (!response.access_token) {
            throw new Error("Token refresh failed: access token missing");
          }
          localStorage.setItem("access_token", response.access_token);
          if (response.refresh_token) {
            localStorage.setItem("refresh_token", response.refresh_token);
          }

          error.config.headers[
            "Authorization"
          ] = `Bearer ${response.access_token}`;
          return axios(error.config);
        } catch (refreshError) {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          console.error("Token refresh failed:", refreshError);
          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

interface DecodedToken {
  realm_access?: {
    roles?: string[];
  };
}

export function getRealmRoles(): string[] {
  const token = localStorage.getItem("access_token");
  if (!token) {
    return [];
  }
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.realm_access?.roles || [];
  } catch (error: any) {
    console.error("Failed to decode token:", error);
    return [];
  }
}

const FULL_ACCESS_ROLES = new Set(["SUPER", "ADMIN"]);

export function hasJwtPermission(permission: string): boolean {
  const roles = getRealmRoles();
  if (roles.some((r) => FULL_ACCESS_ROLES.has(r))) return true;
  return roles.includes(permission);
}
